/* Lynx redesign - behaviour for the lynx-* sections. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  if (window.__lynxRedesign) return;
  window.__lynxRedesign = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ------------------------------------------------------------ money */
  function formatMoney(cents, format, sek) {
    cents = Math.round(Number(cents) || 0);
    if (sek) return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    format = format || '{{amount_no_decimals_with_space_separator}} kr';
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_no_decimals_with_space_separator';
    var val;
    switch (key) {
      case 'amount': val = delim(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': val = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': val = delim(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': val = delim(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      default: val = delim(cents, 0, ' ', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  /* ------------------------------------------------------------ toast */
  var toastEl, toastTimer;
  function toast(text, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'lx-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<svg class="lx-ico" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.5 4.5L19.5 6.5"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.querySelector('span').textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, isError ? 4200 : 2600);
  }

  /* ------------------------------------------------------------ cart */
  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: r.cart_add_url || (root + 'cart/add'),
      cart: (r.cart_url || (root + 'cart')) + '.js'
    };
  }

  function addToCart(items, trigger, errorEl, toastText) {
    if (!items.length) return;
    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    } catch (e) { /* ignore */ }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (trigger) { trigger.setAttribute('aria-busy', 'true'); trigger.disabled = true; }

    var body = { items: items };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    fetch(routes().add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          var msg = data.description || data.message || 'Något gick fel. Försök igen.';
          throw new Error(msg);
        }
        return fetch(routes().cart, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = (data && data.sections) || {};
            var drawer = document.querySelector('cart-drawer');
            var usedTheme = false;
            if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
              try {
                window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'lynx-redesign' });
                usedTheme = true;
              } catch (e) { usedTheme = false; }
            }
            try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } })); } catch (e) { /* ignore */ }
            if (!usedTheme) {
              $$('cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
            }
            if (usedTheme && drawer && typeof drawer.show === 'function' && sections.length) {
              drawer.show(trigger || null);
            } else {
              toast(toastText || 'Tillagd i varukorgen');
            }
          });
      })
      .catch(function (err) {
        var msg = (err && err.message) || 'Något gick fel. Försök igen.';
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
        toast(msg, true);
      })
      .then(function () {
        if (trigger) { trigger.removeAttribute('aria-busy'); trigger.disabled = false; }
      });
  }

  function mainAddon() {
    var cb = $('[data-lynx-product] [data-addon]');
    return cb && cb.checked ? cb : null;
  }

  function initForms(root) {
    $$('form[data-lynx-form]', root).forEach(function (form) {
      if (form.__lynx) return; form.__lynx = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        var items = [{ id: Number(idInput.value), quantity: qty }];
        var addon = form.querySelector('[data-addon]');
        if (!addon && form.hasAttribute('data-lynx-with-addon')) addon = mainAddon();
        if (addon && addon.checked) items.push({ id: Number(addon.value), quantity: 1 });
        var btn = e.submitter || form.querySelector('[type="submit"]');
        var host = form.closest('[data-toast]');
        addToCart(items, btn, form.querySelector('[data-error]'), host ? host.getAttribute('data-toast') : null);
      });
    });
    $$('[data-lynx-bundle]', root).forEach(function (btn) {
      if (btn.__lynx) return; btn.__lynx = true;
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
        var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
        var form = btn.closest('[data-lynx-product]');
        addToCart(items, btn, form ? form.querySelector('[data-error]') : null, btn.getAttribute('data-toast'));
      });
    });
  }

  /* ------------------------------------------------------------ price + add-on */
  function initAddon(root) {
    $$('[data-lynx-product]', root).forEach(function (sec) {
      var cb = $('[data-addon]', sec);
      var fmt = sec.getAttribute('data-money-format');
      var baseEl = $('[data-base]', sec);
      var label = cb ? cb.closest('[data-addon-label]') : null;
      /* Base price is read on every update so the variant picker can change it. */
      function update() {
        var base = baseEl ? Number(baseEl.getAttribute('data-base')) : 0;
        var total = base + (cb && cb.checked ? Number(cb.getAttribute('data-addon-price')) || 0 : 0);
        var txt = formatMoney(total, fmt, sec.hasAttribute('data-sek'));
        $$('[data-price]').forEach(function (el) { el.textContent = txt; });
        if (label) label.classList.toggle('is-on', !!(cb && cb.checked));
      }
      sec.__lynxPrice = update;
      if (!cb || cb.__lynx) return; cb.__lynx = true;
      cb.addEventListener('change', update);
      if (cb.checked) update();
    });
  }

  /* ------------------------------------------------------------ variants */
  function initVariants(root) {
    $$('[data-lynx-product]', root).forEach(function (sec) {
      var picker = $('[data-lynx-picker]', sec);
      if (!picker || picker.__lynx) return; picker.__lynx = true;
      var data = $('[data-lynx-variants]', picker);
      var variants = [];
      try { variants = JSON.parse(data.textContent) || []; } catch (e) { return; }
      var form = $('form[data-lynx-main]', sec);
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var btn = $('[data-lynx-main-atc]', sec);
      var baseEl = $('[data-base]', sec);
      var compareEl = $('[data-compare]', sec);
      var notify = $('[data-notify]', sec);
      var notifyLink = notify ? $('[data-notify-link]', notify) : null;
      var atcLabel = sec.getAttribute('data-atc') || 'Lägg i varukorgen';
      var soldLabel = sec.getAttribute('data-soldout') || 'Tillfälligt slut';
      var fmt = sec.getAttribute('data-money-format');
      var sek = sec.hasAttribute('data-sek');
      var radios = $$('input[data-opt]', picker);
      var ids = variants.map(function (v) { return String(v.id); });
      function selected() {
        var opts = [];
        radios.forEach(function (r) { if (r.checked) opts[+r.getAttribute('data-opt')] = r.value; });
        return opts;
      }
      function find(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < opts.length; k++) { if (opts[k] != null && v.options[k] !== opts[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(opts) {
        radios.forEach(function (r) {
          var k = +r.getAttribute('data-opt');
          var test = opts.slice(); test[k] = r.value;
          var v = find(test);
          var lab = r.closest('.lx-opt-v');
          if (lab) lab.classList.toggle('is-oos', !v || !v.available);
        });
      }
      function setBtn(b, available, exists) {
        if (!b) return;
        b.disabled = !available;
        b.textContent = available ? atcLabel : (exists ? soldLabel : 'Inte tillgänglig');
      }
      function apply(push) {
        var opts = selected();
        var v = find(opts);
        markAvailability(opts);
        $$('[data-opt-label]', picker).forEach(function (el) {
          var k = +el.getAttribute('data-opt-label');
          var r = picker.querySelector('input[data-opt="' + k + '"]:checked');
          var span = r ? r.parentNode.querySelector('span') : null;
          if (span) el.textContent = span.textContent;
        });
        var available = !!(v && v.available);
        setBtn(btn, available, !!v);
        var sticky = $('[data-lynx-sticky-atc]');
        setBtn(sticky, available, !!v);
        if (!v) return;
        var prevId = idInput ? idInput.value : null;
        if (idInput) idInput.value = v.id;
        /* keep other add-to-cart forms for this product on the page in sync (e.g. the final CTA) */
        $$('form[data-lynx-with-addon] [name="id"]').forEach(function (inp) {
          if (ids.indexOf(String(inp.value)) > -1 || inp.value === prevId) {
            inp.value = v.id;
            var b2 = inp.form && inp.form.querySelector('[type="submit"]');
            if (b2) { b2.disabled = !available; if (b2.hasAttribute('data-label-soldout')) b2.textContent = available ? b2.getAttribute('data-label-atc') : b2.getAttribute('data-label-soldout'); }
          }
        });
        if (baseEl) baseEl.setAttribute('data-base', v.price);
        if (sec.__lynxPrice) sec.__lynxPrice();
        else $$('[data-price]').forEach(function (el) { el.textContent = formatMoney(v.price, fmt, sek); });
        if (compareEl) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(v.compare_at_price, fmt, sek);
        }
        if (notify) {
          notify.hidden = available;
          if (notifyLink) {
            var href = notifyLink.getAttribute('href') || '';
            var subj = (notify.getAttribute('data-subject-base') || '') + ' (' + v.title + ') finns i lager';
            notifyLink.setAttribute('href', href.split('?')[0] + '?subject=' + encodeURIComponent(subj));
          }
        }
        if (v.featured_media && v.featured_media.id) {
          var g = $('[data-lynx-gallery]', sec);
          if (g && g.__lynxGoMedia) g.__lynxGoMedia(v.featured_media.id);
        }
        if (push && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* ignore */ }
        }
        try { sec.dispatchEvent(new CustomEvent('lynx:variant-change', { bubbles: true, detail: { variant: v } })); } catch (e) { /* ignore */ }
      }
      radios.forEach(function (r) { r.addEventListener('change', function () { apply(true); }); });
      apply(false);
    });
  }

  /* ------------------------------------------------------------ gallery */
  function initGallery(root) {
    $$('[data-lynx-gallery]', root).forEach(function (g) {
      if (g.__lynx) return; g.__lynx = true;
      var track = $('[data-track]', g), thumbs = $$('.lx-thumb', g), count = $('[data-count]', g);
      var slides = $$('.lx-g-slide', g), n = slides.length, cur = 0, tmr;
      if (!track || n < 2) return;
      function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      g.__lynxGoMedia = function (id) {
        for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-media-id') === String(id)) { go(k); return; } }
      };
      thumbs.forEach(function (t) { t.addEventListener('focus', function () { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-i')); }); });
      var prev = $('[data-prev]', g), next = $('[data-next]', g);
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      });
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () {
          cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
          var tw = thumbs[cur] && thumbs[cur].parentNode;
          if (tw && tw.scrollWidth > tw.clientWidth) { var tb = thumbs[cur]; tw.scrollTo({ left: tb.offsetLeft - (tw.clientWidth - tb.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
          if (count) count.textContent = (cur + 1) + ' / ' + n;
        }, 60);
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------ before / after */
  function initBeforeAfter(root) {
    $$('[data-lynx-ba]', root).forEach(function (ba) {
      if (ba.__lynx) return; ba.__lynx = true;
      var r = $('input', ba);
      if (!r) return;
      r.addEventListener('input', function () { ba.style.setProperty('--pos', r.value + '%'); });
      r.addEventListener('pointerdown', function () { ba.classList.add('is-drag'); });
      ['pointerup', 'pointercancel', 'blur'].forEach(function (ev) { r.addEventListener(ev, function () { ba.classList.remove('is-drag'); }); });
    });
    $$('[data-lynx-results]', root).forEach(function (rt) {
      if (rt.__lynx) return; rt.__lynx = true;
      var dotsWrap = rt.parentNode.querySelector('[data-lynx-dots]');
      if (!dotsWrap) return;
      var dots = $$('i', dotsWrap), tm;
      rt.addEventListener('scroll', function () {
        clearTimeout(tm);
        tm = setTimeout(function () {
          var cards = $$('.lx-rcard', rt);
          if (!cards.length) return;
          var w = cards[0].getBoundingClientRect().width + 14;
          var k = Math.round(rt.scrollLeft / w);
          if (rt.scrollLeft + rt.clientWidth >= rt.scrollWidth - 4) k = cards.length - 1;
          dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
        }, 50);
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------ programs */
  function initPrograms(root) {
    $$('[data-lynx-programs]', root).forEach(function (pg) {
      if (pg.__lynx) return; pg.__lynx = true;
      var tabs = $$('.lx-sw', pg), panels = $$('.lx-panel', pg), stage = $$('.lx-stage-i', pg);
      function sel(k, focus) {
        var tab = null;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-k') === k;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) tab = t;
        });
        if (!tab) return;
        if (focus) tab.focus();
        pg.style.setProperty('--lx-glow', tab.getAttribute('data-glow'));
        stage.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-k') === k); });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-k') === k;
          p.hidden = !on;
          if (on && !reduce) { p.classList.remove('is-anim'); void p.offsetWidth; p.classList.add('is-anim'); }
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t.getAttribute('data-k')); });
        t.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') j = 0;
          if (e.key === 'End') j = tabs.length - 1;
          if (j !== null) { e.preventDefault(); sel(tabs[j].getAttribute('data-k'), true); }
        });
      });
      var first = $('[data-first]', pg);
      if (first && tabs[0]) first.addEventListener('click', function () { sel(tabs[0].getAttribute('data-k'), true); });
      pg.__lynxSelect = sel;
    });
  }

  /* ------------------------------------------------------------ reveal + chart */
  var io = null;
  function initReveal(root) {
    var els = $$('.lynx .lx-rv, .lynx [data-lynx-chart]', root).filter(function (el) { return !el.__lynxRv; });
    els.forEach(function (el) { el.__lynxRv = true; });
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
    document.documentElement.classList.add('lynx-js');
  }

  /* ------------------------------------------------------------ sticky bar */
  var stickyBound = false;
  function initSticky() {
    var st = $('[data-lynx-sticky]');
    var mainBtn = $('[data-lynx-main-atc]');
    if (!st || !mainBtn) return;
    if (!designMode && st.parentNode !== document.body) document.body.appendChild(st);
    var btn = $('.lx-btn', st);
    var ticking = false;
    function upd() {
      ticking = false;
      var liveMain = $('[data-lynx-main-atc]');
      var liveSt = $('[data-lynx-sticky]');
      if (!liveMain || !liveSt) return;
      var r = liveMain.getBoundingClientRect(), vh = window.innerHeight;
      var fin = $('[data-lynx-final]');
      var finVisible = false;
      if (fin) { var f = fin.getBoundingClientRect(); finVisible = f.top < vh * 0.65 && f.bottom > vh * 0.35; }
      var on = r.bottom < 0 && !finVisible;
      liveSt.classList.toggle('is-on', on);
      liveSt.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = $('.lx-btn', liveSt); if (b) b.tabIndex = on ? 0 : -1;
    }
    if (!stickyBound) {
      stickyBound = true;
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
    }
    if (btn) btn.tabIndex = -1;
    upd();
  }

  /* ------------------------------------------------------------ init */
  function init(root) {
    root = root || document;
    initForms(root);
    initAddon(root);
    initGallery(root);
    initVariants(root);
    initBeforeAfter(root);
    initPrograms(root);
    initReveal(root);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('.lx-sw');
    var pg = tab && tab.closest('[data-lynx-programs]');
    if (pg && pg.__lynxSelect) pg.__lynxSelect(tab.getAttribute('data-k'));
    var det = e.target && e.target.tagName === 'DETAILS' ? e.target : null;
    if (det) det.open = true;
  });
})();
